import actionCreator from "../shared/services/actionCreator";

export const authSignupAction = actionCreator("authSignupAction");
export const authInvitationAction = actionCreator("authInvitationAction");
export const authSetAction = actionCreator("authSetAction");
export const authSignOutAction = actionCreator("authSignOutAction");

export const authLocalSigninAction = actionCreator("authLocalSigninAction");
